import { DIMBO_CONSTANT } from '../utils/constant';
import { Observable } from 'rxjs';
import { Inject, ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FormControl } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import { CacheService } from '../services/cache.service';
import { CommonService } from '../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../services/authentication.service';
import { SagaiService } from '../services/sagai.service';
import { NgxSpinnerService } from 'ngx-spinner';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
  title = 'dmbr-goodwill-ui';
  tabs;
  selected = new FormControl(0);
  isTokenValidated: boolean = false;
  isErrorDetected: boolean = false;
  isAdditionalInfoUpdated: boolean;
  shscrolledcount: number;
  mTab: any;
  shTab: any;
  sheTab: any;
  mileagevalue: any;
  mileageunit: any;
  isServiceHistorycm: boolean = false;
  mileageUnit: string;
  isServiceHistory: boolean = false;

  // Goodwill Abacus Calculator properties
  vin: string = '';
  partReference: string = '';
  currentMileage: string = '';
  unit: string = ''; // Default to 'km'
  brand: string = '';
  rrdiCode: string = ''; // RRDI Code
  vinReadOnly: boolean = false;
  brandReadOnly: boolean = true;
  statusRequest: string = 'Pending';
  labourAcknowledged: number = 0;
  materialAcknowledged: number = 0;
  oktranlation: any;

  constructor(
    private cacheService: CacheService,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private translationService: TranslateService,
    private authenticationService: AuthenticationService,
    private sagaiService: SagaiService,
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef
  ) {
    translationService.setDefaultLang('en');
    this.shscrolledcount = 0;
  }

  public changeLanguage(langCode: string) {
    this.translationService.use(langCode);
  }

  ngOnInit() {
    this.translationService.setDefaultLang('en');
    this.spinner.show();
    const token = window.location.href.replace(/^.*[&?]token=/, '').replace(/&.*$/, '');
    console.log('before call token: ');
    this.authenticationService.validateToken(token).then((result: any) => {
      this.changeLanguage(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE));
      this.oktranlation = this.translationService.instant('dimbo.i18n.button.ok');
      this.translationService.get(['dimbo.i18n.MS.tab', 'dimbo.i18n.SH.tab', 'dimbo.i18n.SHE.tab'])
        .subscribe(translations => {
          this.localeInitializer(this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_LANGUAGE)).then(() => {
            console.log('localeInitializer: done');
            this.isTokenValidated = true;
            this.initializeGoodwillAbacusCalculator();
          }).catch(e => {
            console.log(e);
          });
        }, (error: any) => {
          this.translationService.use('en');
          this.translationService.get(['dimbo.i18n.MS.tab', 'dimbo.i18n.SH.tab', 'dimbo.i18n.SHE.tab'])
            .subscribe(translations => {
              this.localeInitializer('en').then(() => {
                console.log('localeInitializer: done');
                this.isTokenValidated = true;
                this.initializeGoodwillAbacusCalculator();
              }).catch(e => {
                console.log(e);
              });
            });
        });
      this.spinner.hide();
    },
      (error: any) => {
        this.isErrorDetected = true;
        localStorage.clear();
        this.spinner.hide();
      }
    );
  }

  localeInitializer(localeId: string): Promise<any> {
    return import(
      /* webpackInclude: /\.js$/ */
      `@angular/common/locales/${localeId}.js`
    ).then(module => registerLocaleData(module.default));
  }

  initializeGoodwillAbacusCalculator() {
    const vin = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    const brand = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_REPAIRER_BRAND);
    const rrdiCode = this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_RRDI);

    if (vin) {
      this.vin = vin;
      this.vinReadOnly = true;
    }

    this.brand = brand || '';
    this.rrdiCode = rrdiCode || '';
  }

  onSubmit(): void {
    // Validate form inputs before submission
    if (this.validateGoodwillAbacusCalculator(this.vin, this.partReference, this.currentMileage, this.brand, this.rrdiCode)) {
      console.log('Form submitted:', {
        vin: this.vin,
        partReference: this.partReference,
        currentMileage: `${this.currentMileage} ${this.unit}`,
        brand: this.brand,
        rrdiCode: this.rrdiCode
      });

      this.sagaiService
        .getGoodwillAcknowledgment(
          this.vin,
          Number(this.currentMileage),
          this.unit,
          this.partReference,
          this.rrdiCode,
          this.brand
        )
        .subscribe(
          (response) => {
            console.log('API Response:', response);
            this.statusRequest = response.statusRequest || 'Processed';  // Handle default status
            this.labourAcknowledged = response.labourAcknowledged || 0;
            this.materialAcknowledged = response.materialAcknowledged || 0;
            this.cd.detectChanges(); // Trigger change detection
          },
          (error) => {
            console.error('Error occurred:', error);
            this.statusRequest = 'Pending';  // Handle error state
            this.labourAcknowledged = 0;
            this.materialAcknowledged = 0;
            this.cd.detectChanges(); // Trigger change detection
          }
        );
    }
  }

  // Validation logic for Goodwill Abacus Calculator form
  validateGoodwillAbacusCalculator(vin: string, partReference: string, currentMileage: string, brand: string, rrdiCode: string): boolean {
    // VIN validation
    if (!vin) {
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.vin'), this.translationService.instant('dimbo.i18n.message.validation.error'), {
        timeOut: 5000,
      });
      return false;
    }

    // Part Reference and Current Mileage validation
    if (!partReference && !currentMileage) {
        this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.partReferenceAndMileage'), this.translationService.instant('dimbo.i18n.message.validation.error'), {
         timeOut: 5000,
           });
            return false;
            }
    
    // Current Mileage validation
    if (!partReference) {
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.partReference'), this.translationService.instant('dimbo.i18n.message.validation.error'), {
        timeOut: 5000,
      });
      return false;
    }

    // Current Mileage validation
    if (!currentMileage) {
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.currentMileage'), this.translationService.instant('dimbo.i18n.message.validation.error'), {
        timeOut: 5000,
      });
      return false;
    }

    // Brand validation
    if (!brand) {
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.brand'), this.translationService.instant('dimbo.i18n.message.validation.error'), {
        timeOut: 5000,
      });
      return false;
    }

    // RRDI Code validation
    if (!rrdiCode) {
      this.toastrService.warning(this.translationService.instant('dimbo.i18n.validation.rrdiCode'), this.translationService.instant('dimbo.i18n.message.validation.error'), {
        timeOut: 5000,
      });
      return false;
    }

    return true;
  }

  /*// Helper method to check if a value is a positive integer
  isPositiveInteger(n: any): boolean {
    return /^\d+$/.test(n); // Checks if the input contains only digits (0-9)
  }*/

  allowAddService() {
    this.onSubmit(); // Call the onSubmit method to handle form submission
  }
}